
<template>
  <div>
    <v-row>
      <v-col cols="6" class="py-0">
        <v-select
          :items="job_interval_options"
          v-model="start_job"
          label="Início da jornada"
          :rules="required"
          item-disabled="start_disabled"
        >
        </v-select>
      </v-col>
      <v-col cols="6" class="py-0">
        <v-select
          :items="job_interval_options"
          v-model="end_job"
          label="Fim da jornada"
          :rules="required"
          item-disabled="end_disabled"
        ></v-select>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import validations from '@/mixins/validations'

export default {
  name: 'SelectJobInterval',
  mixins: [
    validations 
  ],
  data() {
    return {
      job_interval_options: [
        { text: '00:00', start_disabled: false, end_disabled: false },
        { text: '01:00', start_disabled: false, end_disabled: false },
        { text: '02:00', start_disabled: false, end_disabled: false },
        { text: '03:00', start_disabled: false, end_disabled: false },
        { text: '04:00', start_disabled: false, end_disabled: false },
        { text: '05:00', start_disabled: false, end_disabled: false },
        { text: '06:00', start_disabled: false, end_disabled: false },
        { text: '07:00', start_disabled: false, end_disabled: false },
        { text: '08:00', start_disabled: false, end_disabled: false },
        { text: '09:00', start_disabled: false, end_disabled: false },
        { text: '10:00', start_disabled: false, end_disabled: false },
        { text: '11:00', start_disabled: false, end_disabled: false },
        { text: '12:00', start_disabled: false, end_disabled: false },
        { text: '13:00', start_disabled: false, end_disabled: false },
        { text: '14:00', start_disabled: false, end_disabled: false },
        { text: '15:00', start_disabled: false, end_disabled: false },
        { text: '16:00', start_disabled: false, end_disabled: false },
        { text: '17:00', start_disabled: false, end_disabled: false },
        { text: '18:00', start_disabled: false, end_disabled: false },
        { text: '19:00', start_disabled: false, end_disabled: false },
        { text: '20:00', start_disabled: false, end_disabled: false },
        { text: '21:00', start_disabled: false, end_disabled: false },
        { text: '22:00', start_disabled: false, end_disabled: false },
        { text: '23:00', start_disabled: false, end_disabled: false },
      ],
      start_job: '',
      end_job: '',
    }
  },
  methods: {
    disableEndOptions() {
      this.job_interval_options.map(opt => {
        if (opt.text <= this.start_job) {
          opt.end_disabled = true;
        }
      })
    },
    disableStartOptions() {
      this.job_interval_options.map(opt => {
        if (opt.text >= this.end_job) {
          opt.start_disabled = true;
        }
      })
    },
    ...mapActions({
      updateJobInterval: 'Execution/updateJobInterval'
    })
  },
  computed: {
    ...mapState({
      current_execution: state => state.Execution.current_execution
    })
  },
  watch: {
    start_job(nv) {
      if (nv){
        this.updateJobInterval({start: nv});
        this.disableEndOptions();
      }
    },
    end_job(nv) {
      if(nv) {
        this.updateJobInterval({end: nv});
        this.disableStartOptions();
      }
    }
  },
}
</script>

<style scoped>

</style>